import { styled } from '@mui/system';
import { Box, Typography } from '@mui/material';
import { fontFamilies } from '../../constants/theme';
import { figmaLetterSpacing } from '../../ui/utils';
import { colors } from '../../constants/theme';

export const BenefitsOverviewWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'maxWidth',
})(({ maxWidth = 1050, theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 100,
  maxWidth: maxWidth,
  [theme.breakpoints.down(1000)]: {
    gap: 40,
  },
  [theme.breakpoints.down(920)]: {
    flexDirection: 'column',
    gap: 40,
    alignItems: 'stretch',
    padding: '0 20px',
  },
  [theme.breakpoints.down('sm')]: {
    gap: 30,
    padding: '0 16px',
  },
}));

export const BenefitsOverviewTitle = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: '50px',
  lineHeight: '58px',
  fontWeight: 400,
  letterSpacing: figmaLetterSpacing(50, -1),
  color: theme.palette.text.primary,
  [theme.breakpoints.down('md')]: {
    fontSize: '36px',
    lineHeight: '42px',
    letterSpacing: figmaLetterSpacing(36, -1),
    textAlign: 'center',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '28px',
    lineHeight: '34px',
    letterSpacing: figmaLetterSpacing(28, -1),
  },
}));

export const BenefitsOverviewText = styled(Typography)(({ theme }) => ({
  fontFamily: fontFamilies.quicksand,
  fontSize: '20px',
  lineHeight: 'initial',
  fontWeight: 400,
  letterSpacing: figmaLetterSpacing(20, 3),
  color: theme.palette.text.primary,
  maxWidth: 450,
  [theme.breakpoints.down('md')]: {
    fontSize: '18px',
    letterSpacing: figmaLetterSpacing(18, 3),
    maxWidth: '100%',
    textAlign: 'center',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '16px',
    letterSpacing: figmaLetterSpacing(16, 3),
  },
}));

export const BenefitsOverviewListTitle = styled(Typography)(({ theme }) => ({
  fontFamily: fontFamilies.quicksand,
  fontSize: '22px',
  lineHeight: '100%',
  fontWeight: 400,
  letterSpacing: figmaLetterSpacing(22, 3),
  color: theme.palette.text.primary,
  [theme.breakpoints.down('md')]: {
    fontSize: '20px',
    letterSpacing: figmaLetterSpacing(20, 3),
    textAlign: 'center',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '18px',
    letterSpacing: figmaLetterSpacing(18, 3),
  },
}));

export const BenefitsOverviewListItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  padding: 20,
  gap: 20,
  backgroundColor: colors.whiteText,
  borderRadius: 23,
  boxShadow:
    ' -4px -4px 17.8px 0px rgba(205, 214, 223, 0.15), 4px 4px 15px 0px rgba(205, 214, 223, 0.25)',
  [theme.breakpoints.down('sm')]: {
    padding: 16,
    gap: 16,
    borderRadius: 16,
  },
}));

export const BenefitsOverviewListItemText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'maxWidth',
})(({ maxWidth = 412, theme }) => ({
  fontFamily: fontFamilies.quicksand,
  fontSize: '18px',
  lineHeight: 'initial',
  fontWeight: 400,
  letterSpacing: figmaLetterSpacing(18, 2),
  color: theme.palette.text.primary,
  maxWidth: maxWidth,
  width: '100vw',
  [theme.breakpoints.down('md')]: {
    maxWidth: '100%',
    width: '100%',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '16px',
    letterSpacing: figmaLetterSpacing(16, 2),
  },
  '& b': {
    fontWeight: 600,
  },
}));
